// extracted by mini-css-extract-plugin
module.exports = {"message":"RequestMessage_message__2S9yG","title":"RequestMessage_title__3xpOp","content":"RequestMessage_content__1Oyso"};